import type {
  ExistingTreeRepairPlan,
} from './ExistingTreeRepairPlan';
import type {
  ExistingTreeRepairPlanGrouping,
} from './ExistingTreeRepairPlanGrouping';
import type {
  ExistingTreeRepairRendererCertification,
} from './ExistingTreeRepairRendererCertification';
import type {
  ExistingTreeRepairPlanSummary,
} from './ExistingTreeRepairPlanSummary';

export interface ExistingTreeRepairBrowserEvidenceInput {
  generatedAt: string;
  effectiveOwnerUserId: string | null;
  source: 'FamilyGraphContext';
  mode: 'dry-run';
  report: ExistingTreeRepairPlan;
  summary: ExistingTreeRepairPlanSummary;
  grouping: ExistingTreeRepairPlanGrouping;
  rendererCertification:
    ExistingTreeRepairRendererCertification;
  capturedFromUrl: string;
  capturedAt: string;
}

export interface ExistingTreeRepairBrowserEvidence {
  evidenceType:
    'TREE_STRUCTURAL_REPAIR_BROWSER_EVIDENCE';
  generatedAt: string;
  capturedAt: string;
  capturedFromUrl: string;
  effectiveOwnerUserId: string | null;
  source: 'FamilyGraphContext';
  mode: 'dry-run';
  report: ExistingTreeRepairPlan;
  summary: ExistingTreeRepairPlanSummary;
  grouping: ExistingTreeRepairPlanGrouping;
  rendererCertification:
    ExistingTreeRepairRendererCertification;
  deployedBrowserEvidenceCaptured: true;
  certificationAllowed: false;
  executionAllowed: false;
  productionWritesAllowed: false;
}

export function buildExistingTreeRepairBrowserEvidence(
  input: ExistingTreeRepairBrowserEvidenceInput,
): ExistingTreeRepairBrowserEvidence {
  return {
    evidenceType:
      'TREE_STRUCTURAL_REPAIR_BROWSER_EVIDENCE',
    generatedAt: input.generatedAt,
    capturedAt: input.capturedAt,
    capturedFromUrl: input.capturedFromUrl,
    effectiveOwnerUserId:
      input.effectiveOwnerUserId,
    source: input.source,
    mode: input.mode,
    report: input.report,
    summary: input.summary,
    grouping: input.grouping,
    rendererCertification:
      input.rendererCertification,
    deployedBrowserEvidenceCaptured: true,
    certificationAllowed: false,
    executionAllowed: false,
    productionWritesAllowed: false,
  };
}
